import { createAppState } from '../state/app';
import { of } from 'rxjs';
import { Chapter, PagePath } from '../models/page-model';
import { LLC } from '../models/questionnaire-model';
import { ProductName } from '../constants/product-domain';
import * as i0 from "@angular/core";
import * as i1 from "../state/app/app.service";
import * as i2 from "ngx-cookie/src/cookie.service";
import * as i3 from "./environment.service";
import * as i4 from "./auth.service";
import * as i5 from "./processing-order.service";
import * as i6 from "./user-cart.service";
import * as i7 from "./order.service";
import * as i8 from "@angular/router";
import * as i9 from "./questionnaire/questionnaire.service";
import * as i10 from "./questionnaire-answer.service";
import * as i11 from "@legalzoom/business-formation-sdk";
import * as i12 from "./utility.service";
import * as i13 from "./tracking/track-sem-data.service";
import * as i14 from "./experiments/experiments.service";
export class AppInitializationService {
    constructor(appService, cookieService, environmentService, authService, processingOrderService, userCartService, orderService, router, llcQuestionnaireService, questionnaireAnswerService, queueService, utilityService, trackSemDataService, trackjsErrorLogService, experimentsService) {
        this.appService = appService;
        this.cookieService = cookieService;
        this.environmentService = environmentService;
        this.authService = authService;
        this.processingOrderService = processingOrderService;
        this.userCartService = userCartService;
        this.orderService = orderService;
        this.router = router;
        this.llcQuestionnaireService = llcQuestionnaireService;
        this.questionnaireAnswerService = questionnaireAnswerService;
        this.queueService = queueService;
        this.utilityService = utilityService;
        this.trackSemDataService = trackSemDataService;
        this.trackjsErrorLogService = trackjsErrorLogService;
        this.experimentsService = experimentsService;
        this.isReloaded = false;
    }
    initializeApp(currentRoutePath) {
        this.currentRoutePath = `.${currentRoutePath}`;
        const readOnlyAppState = this.appService.app;
        const sessionId = this.cookieService.get(this.environmentService.getTimestringCookie()) || readOnlyAppState.sessionId;
        const authToken = this.utilityService.getAuthTokenConsultationCookie() || readOnlyAppState.accessToken;
        const customerId = this.utilityService.getCustomerIdConsultationCookie() || readOnlyAppState.customerId;
        const tempProcessingOrderId = this.utilityService.getIntParamFromQueryString('uo') || readOnlyAppState.processingOrderId;
        const tempCartId = this.utilityService.getIntParamFromQueryString('cartId') || readOnlyAppState.cartId;
        const tempOrderId = this.utilityService.getIntParamFromQueryString('orderId') || readOnlyAppState.orderId;
        const kenshooID = this.utilityService.getStringParamFromQueryString('kid');
        if (kenshooID) {
            this.trackSemDataService.setSEMCookies();
        }
        if (this.experimentsService.getGloDesignTest() && this.isReloaded) {
            return of(true);
        }
        this.isReloaded = true;
        if (sessionId && authToken && customerId) {
            console.log('App Initialization: SessionId: ' + sessionId + ' AuthToken: ' + authToken + ' CustomerId: ' + customerId);
            this.appService.sessionId = sessionId;
            this.appService.accessToken = authToken;
            this.appService.customerId = customerId;
            this.queueService.add(this.authService.prepareGetCustomerAndSession(sessionId, authToken, customerId));
            const queueEntries = [];
            if (tempCartId) {
                queueEntries.push(this.userCartService.prepareGetCartById(this, this.appService, tempCartId, customerId, ProductName.LLC));
            }
            if (tempProcessingOrderId) {
                queueEntries.push(this.processingOrderService.prepareGetProcessingOrderById(this, this.appService, tempProcessingOrderId, authToken, customerId, ProductName.LLC));
                queueEntries.push(this.llcQuestionnaireService.prepareGetQuestionnaireStorage(this, customerId, tempProcessingOrderId, authToken, ProductName.LLC, (data) => {
                    this.setllcInSession(data);
                }));
                queueEntries.push(this.questionnaireAnswerService.prepareGetUserAnswers(this, customerId, tempProcessingOrderId, ProductName.LLC));
            }
            if (tempOrderId) {
                queueEntries.push(this.orderService.prepareGetOrderById(this, this.appService, tempOrderId, customerId, authToken, ProductName.LLC));
            }
            if (queueEntries && queueEntries.length > 0) {
                this.queueService.add(queueEntries);
            }
            this.queueService.add(this.questionnaireAnswerService.prepareDeleteQuestionnaireAnswers(this, customerId, ProductName.LLC, (data) => {
                this.successDeleteQuestionnaireAnswers(data);
            }));
            this.queueService.add(this.prepareNavigateToCustomerStartPoint(this));
            // this.experimentService.setupExperiments();
            return this.queueService.process();
        }
        else {
            console.log('App Initialization. Else condition. ');
            return this.NavigateToCustomerStartPoint(this, '');
        }
    }
    // timestringExists() {
    //   if (this.userService.user.timestring === undefined || !this.userService.user.timestring || this.userService.user.timestring.length === 0) {
    //     this.userService.user.timestring = this.cookieService.get(this.environmentService.getTimestringCookie());
    //   }
    //   return (this.userService.user.timestring && this.userService.user.timestring.length > 0) ? true : false;
    // }
    NavigateToCustomerStartPoint(context, url) {
        let returnValue = true;
        if (url) {
            this.navigateToURL(url);
        }
        else if (this.utilityService.getStringParamFromQueryString('entity')) {
            this.llcQuestionnaireService.LLC = new LLC();
            this.llcQuestionnaireService.LLC.entityName = this.utilityService.getStringParamFromQueryString('entity');
            this.appService.app = createAppState({});
            const navigationURL = './' + Chapter.Name + '/' + PagePath.BusinessState;
            this.navigateToURL(navigationURL);
        }
        else if (this.utilityService.getStringParamFromQueryString('choose_later')) {
            this.llcQuestionnaireService.LLC = new LLC();
            this.llcQuestionnaireService.LLC.entityName = null;
            this.appService.app = createAppState({});
            const navigationURL = './' + Chapter.Name + '/' + PagePath.BusinessState;
            this.navigateToURL(navigationURL);
        }
        else if (this.utilityService.getStringParamFromQueryString('state')) {
            this.llcQuestionnaireService.LLC = new LLC();
            this.llcQuestionnaireService.LLC.entityState = this.utilityService.getStringParamFromQueryString('state');
            this.appService.app = createAppState({});
            const navigationURL = './' + Chapter.Name + '/' + PagePath.NameAvailable;
            this.navigateToURL(navigationURL);
        }
        else {
            if (window.location.href.indexOf('localhost') < 0) {
                window.location.href = PagePath.LLCLandingPage;
                returnValue = true;
            }
            else {
                this.navigateToURL(`./${Chapter.Name}/${PagePath.ChangeName}`);
            }
        }
        return of(returnValue);
    }
    navigateToURL(url) {
        const currentUrl = this.currentRoutePath.indexOf('?') > 0 ? this.currentRoutePath.substring(0, this.currentRoutePath.indexOf('?')) : this.currentRoutePath;
        if (currentUrl !== url) {
            this.router.navigate([url]);
        }
    }
    setllcInSession(data) {
        const llc = this.llcQuestionnaireService.llc;
        const jsonObj = JSON.parse(data.answers);
        const llcObj = jsonObj;
        this.llcQuestionnaireService.setLLC(llcObj);
        // Object.keys(llc).forEach(property => {
        //   llc[property] = llcObj[property];
        // });
        // this.llcQuestionnaireService.llc = llc;
    }
    successDeleteQuestionnaireAnswers(response) {
        if (response) {
            this.llcQuestionnaireService.llc = new LLC();
        }
    }
    prepareNavigateToCustomerStartPoint(context) {
        const that = this;
        return {
            name: 'prepareValidateSession app-initialization.service',
            pre: () => {
                return of(true);
            },
            post: (response) => {
                const readOnlyAppState = this.appService.app;
                if (readOnlyAppState && readOnlyAppState.processingOrderId && readOnlyAppState.orderId) {
                    if (!readOnlyAppState.isQuestionnaireComplete) {
                        return context.NavigateToCustomerStartPoint(context, `./${Chapter.PostOrder}/${PagePath.RemainingQuestions}`);
                    }
                    else {
                        return context.NavigateToCustomerStartPoint(context, '');
                    }
                }
                else if (readOnlyAppState && readOnlyAppState.cartId && readOnlyAppState.processingOrderId) {
                    let getUrl = null;
                    if (this.llcQuestionnaireService.llc.currentView === `${Chapter.Checkout}/${PagePath.Checkout}`) {
                        getUrl = `./${Chapter.Package}/${PagePath.BofA}`;
                    }
                    else {
                        getUrl = `./${this.llcQuestionnaireService.llc.currentView}`;
                    }
                    if (this.llcQuestionnaireService.llc.currentView === undefined || this.llcQuestionnaireService.llc.currentView === null) {
                        return context.NavigateToCustomerStartPoint(context, '');
                    }
                    else {
                        return context.NavigateToCustomerStartPoint(context, getUrl);
                    }
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackjsErrorLogService.track(ProductName.LLC, 'app-initialization.service', error);
                return of(null);
            }
        };
    }
}
AppInitializationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppInitializationService_Factory() { return new AppInitializationService(i0.ɵɵinject(i1.AppService), i0.ɵɵinject(i2.CookieService), i0.ɵɵinject(i3.EnvironmentService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.ProcessingOrderService), i0.ɵɵinject(i6.UserCartService), i0.ɵɵinject(i7.OrderService), i0.ɵɵinject(i8.Router), i0.ɵɵinject(i9.QuestionnaireService), i0.ɵɵinject(i10.QuestionnaireAnswerService), i0.ɵɵinject(i11.QueueService), i0.ɵɵinject(i12.UtilityService), i0.ɵɵinject(i13.TrackSEMDataService), i0.ɵɵinject(i11.TrackJsErrorLogService), i0.ɵɵinject(i14.ExperimentsService)); }, token: AppInitializationService, providedIn: "root" });
